import { formatDate } from '@angular/common';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_446 implements Validator {

    public static id = 'CTRL_446';
    private message = 'error.ctr_446';


    public LOG: LogService = new LogService(CTRL_446);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_446.id + '_');


        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const dateFinDiffusionNameWithStepId = map.get(ctrl.value.rgCtrls.dateFinDiffusion);
                const datePublicationNameWithStepId = map.get(ctrl.value.rgCtrls.datePublication);
                
                const dateFinDiffusionCtrl = form.controls[dateFinDiffusionNameWithStepId];
                const datePublicationCtrl = form.controls[datePublicationNameWithStepId];
                if (dateFinDiffusionCtrl != undefined) {
                    if (dateFinDiffusionCtrl.value !== 'yyyy-MM-dd' && dateFinDiffusionCtrl.value !== '') {
                        const dateFinDiffusion = new Date(dateFinDiffusionCtrl.value);
                        if (datePublicationCtrl.value !== 'yyyy-MM-dd' && datePublicationCtrl.value !== '' && datePublicationCtrl.value < formatDate(dateFinDiffusion.setDate(dateFinDiffusion.getDate() - 7), 'yyyy-MM-dd', 'en')) {
                            // placer le message d'erreur
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                        } else {
                            form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                        }
                    }
                }
            }
        }
    }
}
